<template>
	<b-navbar toggleable="lg" type="dark" variant="dark">
		<b-container>
			<b-navbar-brand href="#">Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<!-- Right aligned nav items -->
				<b-navbar-nav class="ml-auto" right>
					<b-nav-item-dropdown text="Business">
						<router-link class="w-link" to="/employers">Employers</router-link><br/>
						<router-link class="w-link" to="/customers">Customers</router-link><br/>
						<router-link class="w-link" to="/livesessions">Live Sessions</router-link><br/>
						<router-link class="w-link" to="/customeruploads">Customer Uploads</router-link><br/>
						<router-link class="w-link" to="/untagged">Untagged Transactions</router-link><br/>
						<router-link class="w-link" to="/aichatsettings">AI Chat Settings</router-link><br/>
						<router-link class="w-link" to="/lgtclientlinks">LGT Client Links</router-link>
					</b-nav-item-dropdown>
					<b-nav-item-dropdown text="Content">
						<router-link class="w-link" to="/cms">CMS</router-link><br/>
						<router-link class="w-link" to="/cdn">CDN</router-link><br/>
						<router-link class="w-link" to="/psms">PSMs</router-link><br/>
						<router-link class="w-link" to="/allpsms">PSM Map</router-link><br/>
						<router-link class="w-link" to="/products">Marketplace</router-link><br/>
						<router-link class="w-link" to="/achievements">Achievements</router-link><br/>
						<router-link class="w-link" to="/wellbeing">Wellbeing</router-link><br/>
						<router-link class="w-link" to="/financialplans">Plan your Finances</router-link><br/>
						<router-link class="w-link" to="/questions">Questions</router-link><br/>
					</b-nav-item-dropdown>
					<b-nav-item-dropdown text="Lists">
						<router-link class="w-link" to="/criteria">Criteria</router-link><br/>
						<router-link class="w-link" to="/whitelistfactcard">AI Context Facts</router-link><br/>
						<router-link class="w-link" to="/stats">Stats</router-link><br/>
						<router-link class="w-link" to="/lists">Lists</router-link><br/>
						<router-link class="w-link" to="/merchants">Merchants</router-link><br/>
						<router-link class="w-link" to="/classifications">Spend Classifications</router-link>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
</template>

<script>
export default {
 props: {
   menuMode: String
 },
 methods: {
   menuEvent(mode) {
		this.menuMode = mode;
		this.$emit('menuEvent', mode);
   }
 }
}
</script>

<style>
	.ml-auto {
		margin-left:auto;
	}
	.w-link, .w-link:hover, .w-link:active {
		color: rgb(43, 43, 43);
		text-decoration: none;
		font-size: 14px;
		white-space: nowrap;
		margin-left: 10px;
	}
</style>